/**
 * Regex to check if an email address is valid
 * @see https://www.w3resource.com/javascript/form/email-validation.php
 */
export const EMAIL_REGEX = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
